<template>
    <el-row class="crm-content-container px-4">
        <!-- Open CRM Flag -->
        <div v-if="branchInfo.fsCrmEnable">
            <!-- Coupon List -->
            <div v-if="isLoading">
                <el-col>
                    <CouponCard class="crm-card-coupon-card" isLoading />
                    <CouponCard class="crm-card-coupon-card" isLoading />
                    <CouponCard class="crm-card-coupon-card" isLoading />
                </el-col>
            </div>
            <el-col v-else-if="couponList && couponList.length > 0">
                <div v-for="(coupon, index) in couponList" :key="index" class="crm-card-coupon-card">
                    <SvgUse v-if="coupon.status == 1" class="crm-card-coupon-badge" />
                    <SvgUsed v-if="coupon.status == 2" class="crm-card-coupon-badge" />
                    <SvgExpire v-if="coupon.status == 3" class="crm-card-coupon-badge" />
                    <CouponCard :coupon="coupon" @click.native="handlerCouponCard(index)"/>
                </div>
            </el-col>
            <!-- Non Coupon List -->
            <el-col v-else-if="!isError" class="crm-nothing-here">
                <nothing-to-see-here
                    useImg="coupon-not-found.png"
                    :mainText="$t('components.coupon.coupon-yet')"
                    :subText="$t('components.coupon.can-redeem')"
                />
            </el-col>
            <el-col v-else class="crm-nothing-here">
                <nothing-to-see-here
                    useImg="oops-error.webp"
                    :mainText="$t('history.sorry')"
                    :subText="$t('history.unable-retrieve')"
                    @click-reload="fetchCouponList"
                    haveReloadBtn
                />
            </el-col>
        </div>
        <!-- Close CRM Flag -->
        <div v-else-if="!branchInfo.fsCrmEnable || branchInfo.disabledFlag">
            <el-col class="crm-nothing-here">
                <nothing-to-see-here
                    useImg="crm-close.png"
                    :mainText="$t('components.coupon.branch-closed')"
                    :subText="$t('components.coupon.sorry-inconvenience')"
                />
            </el-col>
        </div>
    </el-row>
</template>

<script>
import CouponCard from '@components/coupon/CouponCard'
const SvgUse = () => import("@/assets/svg/coupon-use.svg")
const SvgUsed = () => import("@/assets/svg/coupon-used.svg")
const SvgExpire = () => import("@/assets/svg/coupon-expire.svg")
const NothingToSeeHere = () => import('@/components/NothingToSeeHere.vue')

import { mapActions, mapGetters } from 'vuex'
import GATracking from "@/helper/GATrackingMixins";

export default {
    components: {
        CouponCard,
        SvgUse,
        SvgUsed,
        SvgExpire,
        NothingToSeeHere,
    },
    mixins: [GATracking],
    data() {
        return {
            isLoading: false,
            isError: null,
        };
    },
    async mounted() {
        if (this.branchInfo.fsCrmEnable) this.fetchCouponList(this.branchUUID)
    },
    methods: {
        ...mapActions({
            fetchCouponListAction: 'coupon/fetchCouponList',
            setCouponDetail: 'coupon/setCouponDetail'
        }),
        handlerCouponCard(index) {
            this.trackReward(3, 'CRMMyCoupon');
           this.setCouponDetail(this.couponList[index])
        },
        fetchCouponList() {
            this.isLoading = true;
            this.fetchCouponListAction(this.branchUUID)
                .then(() => {
                    this.isError = null;
                })
                .catch((error) => {
                    this.isError = error;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },
    computed: {
        ...mapGetters({
            userInfo: 'user/userInfo',
            branchInfo: 'branch/branchInfo',
            branchUUID: 'branch/branchUUID',
            couponList: 'coupon/couponList'
        })
    }
}
</script>

<style scoped>
.crm-nothing-here {
    height: var(--full-content-height);
}

.crm-card-coupon-card {
    margin-block: 12px;
}
.crm-card-coupon-card:first-child {
    margin-top: 24px;
}
.crm-card-coupon-card:last-child {
    margin-bottom: 24px;
}

.crm-card-coupon-badge {
    position: absolute;
    left: 0px;
    z-index: 1;
    margin-left: 10px;
    margin-top: 10px;
}
</style>